import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { useMediaQuery } from 'ha/helpers/MediaQuery';
import { LoadableNavBarBottom } from 'ha/modules/NavBarBottom/components/NavBarBottomRoot';

const useStyles = makeStyles()(theme => ({
  fixedFooter: {
    width: '100%',
    zIndex: 1020,
    bottom: 0,
    position: 'sticky',
    background: theme.palette.common.white,
  },
}));

interface OwnProps {
  fixedFooterContent?: React.ReactNode;
  isAuthenticated: boolean;
  showBottomNav?: boolean;
}

export const FixedFooterSection: React.FC<OwnProps> = ({
  fixedFooterContent,
  isAuthenticated,
  showBottomNav,
}) => {
  const {
    classes: { fixedFooter },
  } = useStyles();
  const { md } = useMediaQuery();

  const isBottomNavVisible = !md && isAuthenticated && showBottomNav;

  return (
    <div className={fixedFooter}>
      {fixedFooterContent}
      {isBottomNavVisible && <LoadableNavBarBottom />}
    </div>
  );
};
